import $ from 'jquery';
import { renameTemplate } from '~loader/loader-api/renameTemplate';
import { handleTabTemplates } from '~src/sidebar/index';

export const renameTemplateClickHandler = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const templateId = $(event.currentTarget).attr('data-giotto-rename-template');
  const isGlobal =
    $(event.currentTarget).attr('data-giotto-isglobal') === 'true';

  await renameTemplate(templateId, isGlobal);
  await handleTabTemplates(true);
};
